import AccountIcon from '@mui/icons-material/AccountCircleRounded';
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { useStyles } from './Login.styles';
import BankIdLogo from '../assets/images/bankid_vector_rgb.svg';
import LoginForm from './LoginForm/LoginForm';
import LoginList from './LoginList/LoginList';
import UserLoginForm from './UserLoginForm';
import Box from '@mui/material/Box';
export const Login = () => {
    const [signInWithEmail, setSignInWithEmail] = useState(false);
    const [bankIDisActive, setBankIDisActive] = useState(false);
    const [bankIDExternalisActive, setBankIDExternalisActive] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const classes = useStyles();
    const toggleLoginMethod = () => {
        setSignInWithEmail(!signInWithEmail);
        setErrorMessage('');
    };
    return (React.createElement(Grid, { container: true, justifyContent: "center" },
        React.createElement(Grid, { item: true, md: 5, sm: 6, xs: 12 },
            React.createElement(Box, { component: "div", sx: classes.card }, !signInWithEmail ? (React.createElement(React.Fragment, null,
                !bankIDExternalisActive && (React.createElement(Box, { component: "div", sx: classes.logotype },
                    React.createElement("img", { src: BankIdLogo, alt: "BankId logo" }))),
                React.createElement(LoginForm, { errorMessage: text => {
                        setErrorMessage(text);
                    }, activeBankID: (state) => setBankIDisActive(state), activeBankIDExternal: (state) => setBankIDExternalisActive(state) }),
                !bankIDisActive && !bankIDExternalisActive && (React.createElement(Box, { component: "div", sx: classes.basicLogin },
                    React.createElement(Button, { onClick: toggleLoginMethod }, "Logga in med l\u00F6senord"))))) : (React.createElement(React.Fragment, null,
                React.createElement(Box, { component: "div", sx: classes.logotype },
                    React.createElement(Box, { component: "div", sx: classes.iconContainer },
                        React.createElement(AccountIcon, { sx: classes.accountIcon }))),
                React.createElement(UserLoginForm, { errorMessage: text => {
                        setErrorMessage(text);
                    } }),
                React.createElement(Box, { component: "div", sx: classes.basicLogin },
                    React.createElement(Button, { onClick: toggleLoginMethod }, "Logga in med BankID"))))),
            React.createElement(React.Fragment, null, errorMessage && (React.createElement(Box, { component: "div", sx: classes.validation },
                React.createElement(ErrorIcon, { sx: classes.validationIcon }),
                React.createElement(Typography, null, errorMessage))))),
        React.createElement(Grid, { item: true, md: 6, sx: { display: { xs: 'none', md: 'block' } } },
            React.createElement(LoginList, null))));
};
export default Login;
